// extracted by mini-css-extract-plugin
export default {"checkBoxContainer":"CustomCheckBox_checkBoxContainer__9duCc","checkboxInput":"CustomCheckBox_checkboxInput__Wsnb3"};